import React from "react";
import { SanityImageSourceExt } from "../../models/shared/SanityImageSourceExt";
import SanityImage from "../SanityImage";

export type PortableTextImageProps = {
  title?: string;
  image?: SanityImageSourceExt;
  width?: "normal" | "wide" | "fullScreen";
};

const PortableTextImage = ({
  image,
  title,
  width = "normal"
}: PortableTextImageProps) => {
  if (image) {
    let classNames = "relative w-full mx-auto mb-12 px-4 md:px-6 lg:mb-32";

    switch (width) {
      case "fullScreen":
        classNames += " max-w-full";
        break;
      case "wide":
        classNames += " max-w-screen-xl";
        break;
      default:
      case "normal":
        classNames += " max-w-3xl";
        break;
    }

    return (
      <div className={classNames}>
        {!!title?.length && <h2 className="mb-4 lg:mb-8">{title}</h2>}
        <SanityImage
          className="rounded-lg rounded-b-none w-full"
          image={image}
          loading="lazy"
        />
      </div>
    );
  } else {
    return null;
  }
};

export default PortableTextImage;
